// extracted by mini-css-extract-plugin
module.exports = {"label":"FilterCustomOption_label__3kxmJ"};